import { makeStyles } from '@material-ui/core';
import statusFactStyles from './statusFactStyles';

const useStyles = makeStyles(theme => ({
  wrapper: ({ isMobile }) => ({
    paddingTop: theme.spacing(isMobile ? 1 : 2),
    paddingLeft: theme.spacing(isMobile ? 0 : 2),
    paddingBottom: theme.spacing(isMobile ? 1 : 2),
    backgroundColor: theme.palette.grey[50]
  }),
  flexRow: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap'
  },
  boldItem: {
    fontWeight: theme.typography.fontWeightMedium
  },
  title: ({ isMobile }) => ({
    paddingRight: theme.spacing(isMobile ? 1 : 6),
    display: 'flex',
    flex: '0 0 100%',
    fontWeight: theme.typography.fontWeightRegular
  }),
  facts: {
    display: 'flex',
    flexBasis: '100%',
    justifyContent: 'space-between',
    padding: theme.spacing(1, 0, 1, 0),
    flexWrap: 'wrap'
  },
  fact: {
    ...statusFactStyles(theme)
  },
  columnHeader: {
    marginLeft: theme.spacing(1)
  },
  arrow: {
    color: theme.palette.text.secondary,
    fontSize: 16,
    margin: theme.spacing(-0.5, 0.5)
  },
  table: {
    display: 'grid',
    alignItems: 'baseline',
    gridRowGap: 0,
    justifyItems: 'start',
    gridColumnGap: 0,
    justifyContent: 'left',
    gridTemplateRows: 'auto',
    gridTemplateColumns: 'auto auto auto auto'
  },
  table2: ({ isMobile, showCost }) => ({
    display: 'grid',
    alignItems: 'baseline',
    gridRowGap: 0,
    justifyItems: 'start',
    justifyContent: 'left',
    gridColumnGap: 0,
    gridTemplateRows: 'auto',
    gridTemplateColumns: isMobile
      ? '40% 34% 26%'
      : showCost
      ? 'auto auto auto auto'
      : 'auto auto auto'
  }),
  row: {
    display: 'contents'
  },
  cell: {
    padding: '6px 16px',
    whiteSpace: 'nowrap'
  },
  header: {
    color: theme.palette.text.secondary
  },
  rowHeader: {
    paddingLeft: theme.spacing(3)
  },
  hours: {
    textAlign: 'right',
    justifySelf: 'end',
    paddingRight: 0
  },
  dates: {
    paddingRight: 0
  },
  label: {
    color: theme.palette.text.secondary
  },
  hoursEstimate: {
    paddingLeft: 0
  },
  plan: {},
  subtext: {
    gridColumn: '2 / span 3',
    fontSize: theme.typography.caption.fontSize
  },
  estimatedPart: {},
  diffNegative: {
    color: theme.palette.error.dark,
    backgroundColor: theme.palette.error.light,
    border: `solid 1px ${theme.palette.error.light}`,
    borderRadius: '0.5em',
    paddingLeft: '2px',
    paddingRight: '2px',
    fontSize: theme.typography.caption.fontSize,
    width: 'fit-content',
    marginLeft: '0.5em'
  },
  onPlan: {
    color: theme.palette.text.secondary
  },
  overPlan: {
    color: theme.palette.error.dark,
    fontWeight: theme.typography.fontWeightBold
  },
  dateRangeOnPlan: {
    '& :last-child': {
      color: theme.palette.text.secondary
    }
  },
  dateRangeOverPlan: {
    '& :last-child': {
      color: theme.palette.error.dark,
      fontWeight: theme.typography.fontWeightBold
    }
  },
  projectedMark: {
    color: theme.palette.text.secondary
  }
}));

export default useStyles;
